var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_1415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.97022 0.000215234C10.8502 0.0302152 13.9302 3.13022 13.9202 6.98022C13.9102 10.8502 10.7702 13.9402 6.89022 13.9102C3.07022 13.8902 -0.0297841 10.7402 0.000215921 6.90022C0.0302159 3.08022 3.17022 -0.0297848 6.97022 0.000215234ZM5.43022 8.24022C4.82022 7.62022 4.26022 7.04022 3.68022 6.47021C3.29022 6.08021 2.80022 6.01022 2.37022 6.25022C1.71022 6.62021 1.59022 7.44022 2.13022 8.00022C2.96022 8.85022 3.80022 9.68022 4.64022 10.5202C5.12022 11.0002 5.75022 10.9802 6.25022 10.4902C8.08022 8.66022 9.91022 6.84022 11.7302 5.01022C12.2302 4.51022 12.2602 3.86022 11.8102 3.41022C11.3502 2.94022 10.7002 2.97022 10.1802 3.49022C9.62022 4.04022 9.07022 4.60021 8.52022 5.15022C7.50022 6.17022 6.49022 7.19022 5.43022 8.26022V8.24022Z",
    fill: "url(#paint0_linear_245_1415)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_1415",
    x1: 0.000215921,
    y1: 6.96022,
    x2: 13.9202,
    y2: 6.96022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_1415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.92,
    height: 13.92,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.dfa063e6db66772572f43e50cebd1cee.svg";
export { ForwardRef as ReactComponent };